﻿import { Stack } from '@chakra-ui/react'
import { useEffect } from 'react'
import type { VinOnlineVehicleDto } from 'BrokerTsLib/src/dtos'

import { CustomWaypoint } from '@/components/CustomWaypoint'
import { PageSection } from '@/components/PageSection'
import { useSidebar } from '@/context/SidebarContext'
import type { PageSection as Section } from '@/layouts/components/Sidebar'
import { StockSection } from './StockSection'
import { VehicleSection } from './VehicleSection'

type Props = {
  isFromPs: boolean
  psVehicle?: VinOnlineVehicleDto | null
  minStartDate: Date
  isPending: boolean
  isDisabled: boolean
  showSubmitButton: boolean
  onDuplicityChange: (isDuplicate: boolean) => void
}

export const CreateStockBody = ({
  isFromPs,
  psVehicle,
  minStartDate,
  isPending,
  isDisabled,
  showSubmitButton,
  onDuplicityChange,
}: Props) => {
  const { setPageSections, pageSections } = useSidebar()

  console.log(isFromPs)

  useEffect(() => {
    const array: Section[] = [
      {
        id: 'vozidlo',
        sectionTitle: 'Vozidlo',
        index: 1,
        children: (
          <VehicleSection
            isFromPs={isFromPs}
            psVehicle={psVehicle}
            onDuplicityChange={onDuplicityChange}
          />
        ),
      },
      {
        id: 'sklad',
        sectionTitle: 'Skladové pojištění',
        index: 2,
        children: (
          <StockSection
            isFromPs={isFromPs}
            minStartDate={minStartDate}
            isPending={isPending}
            isDisabled={isDisabled}
            showSubmitButton={showSubmitButton}
          />
        ),
      },
    ]
    setPageSections(array)
  }, [isFromPs, psVehicle, minStartDate, isPending, isDisabled])

  return (
    <Stack gap={8} sx={{ pt: { base: 0, md: 8 } }}>
      {pageSections.map((x) => (
        <CustomWaypoint key={x.id} sectionId={x.id}>
          <PageSection id={x.id}>{x.children}</PageSection>
        </CustomWaypoint>
      ))}
    </Stack>
  )
}
